import {Component, Input, OnInit} from '@angular/core';
import {DominiosService} from "../../services/dominios.service";
import {ConstantsService} from "../../services/ConstantsService";
import {SharedDataService} from "../../services/shared.data.service";
import {AutorizacaoLojaService} from "../../services/autorizacao-loja.service";

@Component({
  selector: 'app-loja-menu',
  templateUrl: './loja-menu.component.html',
  styleUrls: ['./loja-menu.component.scss']
})
export class LojaMenuComponent implements OnInit {
  @Input() exibirMenu = true;
  url: any = 'index';
  estaNoHome  = true;
  estaNaBuscaPorCategoria = false;
  exibirMenuCategorias = false;
  urlCardapio = '';
  exibirPoweredBy = false;
  usuario: any = {};
  estaNoLocal: boolean;

  constructor(private dominiosService: DominiosService, private constantsService: ConstantsService,
              public sharedDataService: SharedDataService, private autorizacao: AutorizacaoLojaService) { }

  ngOnInit(): void {
    this.usuario = this.autorizacao.getUsuario() || {}

    this.autorizacao.usuario$.subscribe( (usuario) => {
      if(!usuario) return;
      this.usuario = usuario;
    });

   let link = this.dominiosService.obtenhaUrlAtiva();

   if(link !== '') this.url = link;

   this.urlCardapio = location.hostname;

   if( this.urlCardapio.indexOf('meucardapio.ai') !== -1 ) {
     this.exibirPoweredBy = true;
   }

   this.constantsService.empresa$.subscribe( (empresa: any) => {
     if( !empresa) {
       return;
     }

     if( !this.exibirPoweredBy ) this.exibirPoweredBy = empresa.rede === 'chinainbox';
   })

    this.veriqueMenuAtivo();
  }

  naveguePara(url: string) {
    this.url = url;
    this.veriqueMenuAtivo();
    this.dominiosService.navegueParaUrl(url);
  }

  veriqueMenuAtivo(){
    this.estaNoHome = this.url === 'index' || this.url === 'loja' || this.url === '/';
    this.estaNaBuscaPorCategoria = this.url.indexOf('busca') >= 0 &&  this.url.indexOf('ecommerce')
    this.estaNoLocal = this.url.indexOf('local') >= 0;
  }

  clicouExibirMenuCategorias(){
    this.sharedDataService.notifiqueExibirMenu();
  }

}
